import "@rainbow-me/rainbowkit/styles.css";
import "./polyfills";
import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import {
  connectorsForWallets,
  RainbowKitProvider,
} from "@rainbow-me/rainbowkit";
import { createConfig, http, WagmiProvider } from "wagmi";
import { bsc } from "wagmi/chains";
import App from "./App";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  rainbowWallet,
  walletConnectWallet,
  coinbaseWallet,
  bybitWallet,
  injectedWallet,
  metaMaskWallet,
  braveWallet,
  coreWallet,
  ledgerWallet,
  trustWallet,
  uniswapWallet,
  safeWallet,
} from "@rainbow-me/rainbowkit/wallets";

const connectors = connectorsForWallets(
  [
    {
      groupName: "Popular",
      wallets: [
        rainbowWallet,
        walletConnectWallet,
        coinbaseWallet,
        bybitWallet,
        injectedWallet,
        metaMaskWallet,
        braveWallet,
        coreWallet,
        ledgerWallet,
        trustWallet,
        uniswapWallet,
        safeWallet,
      ],
    },
  ],
  {
    appName: "PepeCoinV2",
    projectId: "b456bb3d0d02f576cb9dc579105673ad",
  }
);

const config = createConfig({
  connectors,
  chains: [bsc],
  transports: {
    [bsc.id]: http("https://rpc.ankr.com/bsc/08d1966efe37214196563805bf046804732757d8e34e2cd68287dd4c3198c2ef"),
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

declare module "wagmi" {
  interface Register {
    config: typeof config;
  }
}

const queryClient = new QueryClient();
root.render(
  <React.StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider modalSize="compact" initialChain={bsc}>
          <App />
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
